const init = () => {
  const processLinks = document.querySelectorAll('[data-process]');
  const linkActiveClasses = ['text-wild-yellow'];
  const linkInactiveClasses = ['text-white'];
  const descActiveClasses = ['opacity-100', 'relative'];
  const descInactiveClasses = ['opacity-0', 'absolute', 'top-0', 'left-0'];

  const updateContainerHeight = (uid, step = null) => {
    const firstDesc = document.querySelector(`[data-process-step*="${uid}"]`);
    const container = firstDesc?.parentElement;
    if (container) {
      let activeDesc;
      if (step) {
        const allDescs = container.querySelectorAll('[data-process-step]');
        activeDesc = Array.from(allDescs).find((desc) => {
          const data = JSON.parse(desc.dataset.processStep);
          return data.step === step && data.uid === uid;
        });
      } else {
        activeDesc = container.querySelector('.opacity-100');
      }

      if (activeDesc) {
        container.style.height = 'auto';
        void container.offsetHeight;
        const newHeight = activeDesc.scrollHeight;
        container.style.height = `${newHeight}px`;
      }
    }
  };

  processLinks.forEach((processLink) => {
    processLink.addEventListener('click', (e) => {
      const { step, uid } = JSON.parse(processLink.dataset.process);
      const links = document.querySelectorAll(`[data-process*="${uid}"]`);
      const descs = document.querySelectorAll(`[data-process-step*="${uid}"]`);

      const targetDescs = Array.from(descs).filter((desc) => {
        const data = JSON.parse(desc.dataset.processStep);
        return data.step === step && data.uid === uid;
      });

      links.forEach((link) => {
        link.classList.remove(...linkActiveClasses);
        link.classList.add(...linkInactiveClasses);
      });
      descs.forEach((desc) => {
        desc.classList.remove(...descActiveClasses);
        desc.classList.add(...descInactiveClasses);
      });

      processLink.classList.remove(...linkInactiveClasses);
      processLink.classList.add(...linkActiveClasses);

      targetDescs.forEach((targetDesc) => {
        targetDesc.classList.remove(...descInactiveClasses);
        targetDesc.classList.add(...descActiveClasses);
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updateContainerHeight(uid, step);
        });
      });

      e.preventDefault();
    });
  });

  const allContainers = document.querySelectorAll('[data-process-step]');
  const processedUids = new Set();

  allContainers.forEach((desc) => {
    const data = JSON.parse(desc.dataset.processStep);
    if (!processedUids.has(data.uid)) {
      processedUids.add(data.uid);
      setTimeout(() => updateContainerHeight(data.uid), 10);
    }
  });
};

export default {
  init,
};
